import { FC } from "react";

import { SecondaryOverlay } from "components/constants";
import { t } from "i18n/i18n";
import { Button } from "mds/components/Button";
import { IconText } from "mds/components/IconText";
import { MenuItem } from "mds/components/Menu";
import { RobotAIIcon } from "mds/icons";
import { useOverlayControls } from "utils/routing/hooks/use-overlay-controls";

export const AIPanelToggleButton: FC<{ isMenuItem?: boolean }> = ({ isMenuItem = false }) => {
  const { isSelected, togglePanel } = useOverlayControls(SecondaryOverlay.AIAssistant);

  if (isMenuItem) {
    return (
      <MenuItem
        eventName="AI Assistant - Toggle"
        eventProps={{ isOpened: !isSelected }}
        onClick={togglePanel}
      >
        <IconText iconStart={<RobotAIIcon />} text={t("content_sidebar.title.AiAssistant")} />
      </MenuItem>
    );
  }

  return (
    <Button
      eventName="AI Assistant - Toggle"
      eventProps={{ isOpened: !isSelected }}
      isSelected={isSelected}
      kind="squareLegacy"
      size="l"
      title={t("content_sidebar.title.AiAssistant")}
      isSquare
      onClick={togglePanel}
    >
      <RobotAIIcon />
    </Button>
  );
};
